import React from "react";
import ApiButton from "../../../../shared/ui/Api.Button";
import { applicationConnector } from "../../../../services/applications/connector";
import moment from "moment";
import { backendAdminConnect } from "../../../../reloansys.component/Reloansys.Bar";
import { compose } from "redux";
import { BackendButton } from "../../../../auth/BackendButton";

const KreditzReportsComponent = ({
  application,
  createKreditzReviewCredApp,
}) => {
  return (
    <React.Fragment>
      {application.KreditzReports.map((item) => {
        return (
          <div key={item.Id}>
            <strong>
              ({moment(new Date(item.Date)).format("YYYY-MM-DD HH:mm:ss")})
            </strong>
            <br />
            EnforcementAuthority: {item.EnforcementAuthority} <br />
            KreditzScore: {item.KreditzScore} <br />
            KreditzLongTermScore: {item.KreditzScoreLongTerm} <br />
            KreditzScoreActive: {item.KreditzScoreActive}
            <br />
            CollectionCountAvg: {item.CollectionCountAvg}
            <br />
            InstantLoanPaymentCount: {item.InstantLoanPaymentCount}
            <br />
            KalpValue: {item.KalpValue}
            <br />
            IncomeAvg: {item.IncomeAvg}
            <br />
            MonthCount: {item.MonthCount}
            <br />
            ProbabilityOfDefault: {percentageRender(item.ProbabilityOfDefault)}
            <br />
            MainAccount: {item.MainAccount}
            <br />
            <BackendButton
              label={"Details"}
              url={`/loanstep/kreditz-reports/${item.Id}`}
            />
          </div>
        );
      })}
      <ApiButton
        sending={application.createKreditzReviewPending}
        error={application.kreditzError}
        buttonLabel={"New Kreditz review"}
        onButtonClick={() => createKreditzReviewCredApp(application.Id)}
      />
    </React.Fragment>
  );
};

function percentageRender(value) {
  if (value || value === 0) {
    return Math.round(value * 10000) / 100 + "%";
  }
  return "not set";
}

export default compose(
  backendAdminConnect,
  applicationConnector,
)(KreditzReportsComponent);
